import { Component, OnInit } from '@angular/core';
import { StorageService } from '@app-core/services/storage/storage.service';
import { LoginTypes } from '@app-core/services/google-tag-manager/google-tag-manager.service';
import { DataService } from '@app-core/services/data/data.service';

@Component({
  selector: 'app-tn360-sso-login',
  templateUrl: './tn360-sso-login.component.html',
  styleUrls: ['./tn360-sso-login.component.scss'],
})
export class TN3600SsoLoginComponent implements OnInit {
  constructor(private storageService: StorageService, private dataService: DataService) {}

  ngOnInit(): void {
    this.checkSession();
  }

  private checkSession() {
    const loginInfo = this.storageService.getStorageValue('loginInfo');
    this.dataService.userLogin.next({ loginInfo, redirectUrl: 'home', loginType: LoginTypes.fleetManager });
  }
}
